/* Compositor-driven continuous loop. Source images never open or send messages. */
(() => {
  document.querySelectorAll('[data-ev-proof]').forEach(host => {
    if (host.dataset.proofReady) return;
    host.dataset.proofReady = 'loop';
    const runner = host.querySelector('[data-proof-runner]');
    const track = host.querySelector('[data-proof-track]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const allowed = host.dataset.autoplay === 'true';
    const clone = track.cloneNode(true);
    clone.removeAttribute('data-proof-track');
    clone.setAttribute('data-proof-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.inert = true;
    clone.querySelectorAll('img').forEach(img => { img.alt = ''; });
    runner.append(clone);
    let animation, duration = 1;
    const render = () => {
      const staticMode = !allowed || motion.matches || !runner.animate;
      host.classList.toggle('is-static', staticMode);
      if (!animation) return;
      if (staticMode) animation.pause();
      else animation.play();
      if (staticMode) animation.currentTime = 0;
    };
    const rebuild = () => {
      const fraction = animation ? (animation.currentTime || 0) / duration : 0;
      animation?.cancel();
      const distance = track.getBoundingClientRect().width + parseFloat(getComputedStyle(runner).gap || 0);
      duration = distance / (innerWidth <= 600 ? 24 : 30) * 1000;
      if (runner.animate) {
        animation = runner.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d(-' + distance + 'px,0,0)'}], {duration, iterations:Infinity, easing:'linear'});
        animation.currentTime = fraction * duration;
      }
      render();
    };
    const resizeObserver = new ResizeObserver(rebuild);
    resizeObserver.observe(track);
    motion.addEventListener('change', render);
    rebuild();
    const unload = e => {
      if (!e.target.contains(host)) return;
      animation?.cancel();
      resizeObserver.disconnect();
      motion.removeEventListener('change', render);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  });
})();
